module.exports = __webpack_public_path__ + "img/kieswijs_logo.39729f43.png";